import { FC } from 'react';

import './style.scss';

export const POIInfoSkeleton: FC = () => {
  return (
    <div className="svg-skeleton poi-info-skeleton">
      <svg width="343" height="81" viewBox="0 0 343 81" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="0.5" width="160" height="28" rx="4" fill="#e6e6e6" />
        <rect y="38.5" width="343" height="16" rx="4" fill="#e6e6e6" />
        <rect y="64.5" width="343" height="16" rx="4" fill="#e6e6e6" />
      </svg>
    </div>
  );
};
